<template>
  <div class="pray-activity-container">
    <div class="page-header">
      <h2>祈福活动管理</h2>
    </div>

    <el-card class="form-card" shadow="hover">
      <el-form
        ref="formRef"
        :model="formData"
        :rules="formRules"
        label-width="160px"
        label-position="right"
      >
        <!-- 游戏区选择 -->
        <el-form-item label="游戏区服" prop="serverName">
          <el-select
            v-model="formData.serverName"
            placeholder="请选择游戏区"
            style="width: 350px"
            @change="fetchTodayData"
            clearable
          >
            <el-option
              v-for="area in areas"
              :key="area.value"
              :label="area.label"
              :value="area.label"
            />
          </el-select>
        </el-form-item>

        <!-- 活动时间设置 -->
        <el-form-item label="活动开始时间">
          <el-date-picker
            v-model="formData.startTime"
            type="datetime"
            placeholder="选择活动开始时间"
            style="width: 350px"
            :disabled="!formData.serverName"
            value-format="YYYY-MM-DD HH:mm:ss"
          />
        </el-form-item>

        <el-form-item label="活动结束时间">
          <el-date-picker
            v-model="formData.endTime"
            type="datetime"
            placeholder="选择活动结束时间"
            style="width: 350px"
            :disabled="!formData.serverName"
            value-format="YYYY-MM-DD HH:mm:ss"
          />
        </el-form-item>

        <!-- 保存时间配置按钮 -->
        <el-form-item label="操作">
          <el-button
            type="primary"
            :loading="loading.setTime"
            @click="handleSetPrayerTime"
            :disabled="!formData.serverName || !formData.startTime || !formData.endTime"
          >
            保存活动时间配置
          </el-button>
        </el-form-item>

        <el-divider />

        <!-- 今日祈福参与人员 -->
        <el-form-item label="今日祈福参与人员" prop="participantName">
          <el-select
            v-model="formData.participantName"
            placeholder="请选择中奖人员"
            style="width: 350px"
            clearable
            :disabled="!formData.serverName"
          >
            <el-option
              v-for="name in prayerNameList"
              :key="name"
              :label="name"
              :value="name"
            />
          </el-select>
          <span class="tips">选中后点击按钮设置为今日中奖者</span>
        </el-form-item>

        <!-- 设置中奖 + 清空按钮 -->
        <el-form-item label="操作">
          <el-button
            type="primary"
            :loading="loading.setWinner"
            @click="handleSetWinner"
            :disabled="!formData.participantName || !formData.serverName"
          >
            确认设置为今日中奖者
          </el-button>

          <el-button
            type="warning"
            :loading="loading.clearToday"
            @click="handleClearToday"
            :disabled="!formData.serverName"
            style="margin-left: 10px"
          >
            清空今日选中人员
          </el-button>
        </el-form-item>

        <el-divider />

        <!-- 明日活动开关 -->
        <el-form-item label="今天祈福服务器是否播报">
          <el-switch
            v-model="formData.tomorrowStatus"
            active-text="开启"
            inactive-text="关闭"
            :disabled="!formData.serverName"
            @change="handleSetTomorrowStatus"
          />
        </el-form-item>

        <el-divider />

        <!-- 奖励物品 -->
        <el-form-item label="活动奖励物品" prop="rewardName">
          <el-select
            v-model="formData.rewardName"
            placeholder="请选择奖励物品"
            style="width: 350px"
            :disabled="!formData.serverName"
          >
            <el-option
              v-for="item in rewardList"
              :key="item.name"
              :label="item.name"
              :value="item.name"
            />
          </el-select>
        </el-form-item>

        <!-- 保存奖品配置 -->
        <el-form-item>
          <el-button
            type="success"
            :loading="loading.setGift"
            @click="handleSaveGift"
            :disabled="!formData.rewardName || !formData.serverName"
          >
            保存奖品配置
          </el-button>
        </el-form-item>

        <el-divider />

        <!-- ====================== 补偿功能（可勾选/可取消） ====================== -->
        <el-form-item label="未祈福玩家补偿">
          <el-checkbox-group v-model="selectedGiftList">
            <el-checkbox label="高级喇叭×5" />
            <el-checkbox label="绑定2小时双倍卷轴×1" />
            <el-checkbox label="烟花×10" />
          </el-checkbox-group>
        </el-form-item>

        <el-form-item label="操作">
          <el-button
            type="danger"
            :loading="loading.giveCompensation"
            @click="handleGiveCompensation"
            :disabled="!formData.serverName"
          >
            发放补偿给未祈福玩家
          </el-button>
        </el-form-item>

      </el-form>
    </el-card>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import axios from 'axios'
import { useRouter } from 'vue-router'

const router = useRouter()
const formRef = ref(null)

// 加载状态
const loading = reactive({
  setWinner: false,
  setGift: false,
  setStatus: false,
  setTime: false,
  clearToday: false,
  todayData: false,
  giveCompensation: false
})

// 表单数据
const formData = reactive({
  serverName: '',
  participantName: '',
  tomorrowStatus: true,
  rewardName: '',
  startTime: '',
  endTime: ''
})

// 补偿勾选列表
const selectedGiftList = ref([])

// 游戏区列表
const areas = ref([])
// 祈福人员名单
const prayerNameList = ref([])
// 奖品配置
const rewardList = ref([
  { name: '七星宝箱9' },
  { name: '七星宝箱' },
  { name: '妖丹' },
  { name: '乾坤宝箓' },
  { name: '飞龙宝箱' }
])

// 表单校验
const formRules = {
  serverName: [{ required: true, message: '请选择游戏区', trigger: 'change' }],
  participantName: [{ required: true, message: '请选择中奖人员', trigger: 'change' }],
  rewardName: [{ required: true, message: '请选择奖励物品', trigger: 'change' }]
}

// ==================================
// 1. 获取游戏区列表
// ==================================
const fetchAreas = async () => {
  try {
    const token = sessionStorage.getItem('token')
    if (!token) {
      router.push('/login')
      return
    }
    const res = await axios.get(`https://log.wuxiahaojie.com/api/Area`, {
      headers: { 'Authorization': `Bearer ${token}` }
    })
    if (res.data.code === 200) {
      areas.value = res.data.data || []
    } else {
      ElMessage.error(`获取区服失败：${res.data.msg}`)
    }
  } catch (err) {
    console.error('获取区服异常：', err)
    ElMessage.error('获取区服数据失败')
  }
}

// ==================================
// 2. 选择区服时 → 获取今日数据并回填到表单
// ==================================
const fetchTodayData = async () => {
  if (!formData.serverName) {
    prayerNameList.value = []
    formData.participantName = ''
    formData.startTime = ''
    formData.endTime = ''
    formData.rewardName = ''
    formData.tomorrowStatus = true
    selectedGiftList.value = []
    return
  }

  try {
    loading.todayData = true
    const token = sessionStorage.getItem('token')
    
    const res = await axios.get(`https://log.wuxiahaojie.com/api/PrayerSystem/GetTodayMessage`, {
      params: { serverName: formData.serverName },
      headers: { 'Authorization': `Bearer ${token}` }
    })

    const data = res.data || ''
    const arr = data.split('|')
    
    formData.startTime = arr[0] || ''
    formData.endTime = arr[1] || ''
    const todayStatus = arr[2] || '0'
    const todayReward = arr[3] || ''
    const todayWinner = arr[4] || ''

    formData.rewardName = todayReward
    formData.participantName = todayWinner
    formData.tomorrowStatus = todayStatus === '1'

    fetchPrayerList()

  } catch (err) {
    console.error('获取今日数据异常：', err)
    ElMessage.error('获取今日活动数据失败')
  } finally {
    loading.todayData = false
  }
}

// ==================================
// 3. 获取祈福名单
// ==================================
const fetchPrayerList = async () => {
  try {
    const token = sessionStorage.getItem('token')
    const res = await axios.get(`https://log.wuxiahaojie.com/api/PrayerSystem/GetAllPrayerName`, {
      params: { serverName: formData.serverName },
      headers: { 'Authorization': `Bearer ${token}` }
    })
    prayerNameList.value = res.data.data || []
  } catch (err) {
    ElMessage.error('获取祈福名单失败')
  }
}

// ==================================
// 4. 设置中奖人
// ==================================
const handleSetWinner = async () => {
  try {
    loading.setWinner = true
    const token = sessionStorage.getItem('token')
    const res = await axios.get(`https://log.wuxiahaojie.com/api/PrayerSystem/fixName`, {
      params: {
        name: formData.participantName,
        serverName: formData.serverName
      },
      headers: { 'Authorization': `Bearer ${token}` }
    })

    if (res.data === 'success') {
      ElMessage.success('✅ 设置中奖人成功')
      fetchTodayData()
    } else {
      ElMessage.error('❌ 设置失败')
    }
  } catch (err) {
    ElMessage.error('设置接口异常')
  } finally {
    loading.setWinner = false
  }
}

// ==================================
// 5. 清空今日选中人员
// ==================================
const handleClearToday = async () => {
  try {
    loading.clearToday = true
    const token = sessionStorage.getItem('token')
    const res = await axios.get(`https://log.wuxiahaojie.com/api/PrayerSystem/ClearPrayerName`, {
      params: { serverName: formData.serverName },
      headers: { 'Authorization': `Bearer ${token}` }
    })

    if (res.data === 'success') {
      ElMessage.success('✅ 已清空今日选中人员')
      fetchTodayData()
    } else {
      ElMessage.error('❌ 清空失败')
    }
  } catch (err) {
    ElMessage.error('清空接口异常')
  } finally {
    loading.clearToday = false
  }
}

// ==================================
// 6. 设置奖品
// ==================================
const handleSaveGift = async () => {
  try {
    loading.setGift = true
    const token = sessionStorage.getItem('token')
    const res = await axios.get(`https://log.wuxiahaojie.com/api/PrayerSystem/fixPrayerGift`, {
      params: {
        name: formData.rewardName,
        serverName: formData.serverName
      },
      headers: { 'Authorization': `Bearer ${token}` }
    })

    if (res.data === 'success') {
      ElMessage.success('✅ 奖品配置保存成功')
      fetchTodayData()
    } else {
      ElMessage.error('❌ 保存失败')
    }
  } catch (err) {
    ElMessage.error('奖品接口异常')
  } finally {
    loading.setGift = false
  }
}

// ==================================
// 7. 设置明日活动开关
// ==================================
const handleSetTomorrowStatus = async (val) => {
  if (!formData.serverName) {
    ElMessage.warning('请先选择游戏区')
    formData.tomorrowStatus = !val
    return
  }

  try {
    loading.setStatus = true
    const token = sessionStorage.getItem('token')
    const res = await axios.get(`https://log.wuxiahaojie.com/api/PrayerSystem/fixPrayerIsEnd`, {
      params: {
        isEnd: val ?  0: 1,
        serverName: formData.serverName
      },
      headers: { 'Authorization': `Bearer ${token}` }
    })

    if (res.data === 'success') {
      ElMessage.success(`✅ 已${val ? '开启' : '关闭'}明日活动`)
    } else {
      ElMessage.error('❌ 状态设置失败')
      formData.tomorrowStatus = !val
    }
  } catch (err) {
    ElMessage.error('状态接口异常')
    formData.tomorrowStatus = !val
  } finally {
    loading.setStatus = false
  }
}

// ==================================
// 8. 保存活动时间配置
// ==================================
const handleSetPrayerTime = async () => {
  if (!formData.serverName) {
    ElMessage.warning('请先选择游戏区')
    return
  }
  if (!formData.startTime || !formData.endTime) {
    ElMessage.warning('请选择完整的活动开始和结束时间')
    return
  }

  try {
    loading.setTime = true
    const token = sessionStorage.getItem('token')
    const res = await axios.get(`https://log.wuxiahaojie.com/api/PrayerSystem/fixPrayerTime`, {
      params: {
        StartTime: formData.startTime,
        Endtime: formData.endTime,
        serverName: formData.serverName
      },
      headers: { 'Authorization': `Bearer ${token}` }
    })

    if (res.data === 'success') {
      ElMessage.success('✅ 活动时间配置保存成功')
      fetchTodayData()
    } else {
      ElMessage.error('❌ 时间配置保存失败')
    }
  } catch (err) {
    ElMessage.error('时间配置接口请求失败')
  } finally {
    loading.setTime = false
  }
}

// ==================================
// 9. 发放补偿（选中什么，name就传什么）
// ==================================
const handleGiveCompensation = async () => {
  if (!formData.serverName) {
    ElMessage.warning('请先选择游戏区')
    return
  }

  try {
    loading.giveCompensation = true
    const token = sessionStorage.getItem('token')

    // 选中的奖品文本 → 传给 name 参数
    const sendName = selectedGiftList.value.join(',')

    const res = await axios.get(`https://log.wuxiahaojie.com/api/PrayerSystem/fixPrayerConpensationGift`, {
      params: {
        name: sendName,
        serverName: formData.serverName
      },
      headers: { 'Authorization': `Bearer ${token}` }
    })

    if (res.data === 'success') {
      ElMessage.success('✅ 补偿发放成功！')
    } else {
      ElMessage.error('❌ 发放失败')
    }
  } catch (err) {
    ElMessage.error('补偿接口异常')
  } finally {
    loading.giveCompensation = false
  }
}

// 初始化
onMounted(() => {
  fetchAreas()
})
</script>

<style scoped>
.pray-activity-container {
  padding: 24px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.page-header {
  margin-bottom: 24px;
}

.page-header h2 {
  margin: 0;
  font-size: 22px;
  color: #1f2329;
  font-weight: 600;
}

.form-card {
  max-width: 800px;
  padding: 20px;
}

.tips {
  margin-left: 12px;
  color: #909999;
  font-size: 12px;
}

:deep(.el-form-item) {
  margin-bottom: 24px;
}
</style>